<template>
    <div class="swiperWrap">
        <div v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in carouselImgData" :key="item.id">
                    <router-link :to="{path: `/news/${getUrlTitle(subtit)}/${getUrlTitle(item.title)}/${item.id}`}">
                        <img v-if="index===0" :src="getImgSrc(item.thumb)" class="swiper-lazy">
                        <img v-else :data-src="getImgSrc(item.thumb)" class="swiper-lazy">
                        <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </router-link>
                    <div class="header-mask"></div>
                    <p class="titleWord">{{item.title}}</p>
                </div>
            </div>
            <div class="swiper-pagination swiper-pagination-bullets"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    if (process.browser) {
        // https://github.com/surmon-china/vue-awesome-swiper#use-in-ssr
        const VueAwesomeSwiper = require('vue-awesome-swiper/ssr');
        Vue.use(VueAwesomeSwiper);
    }
    // todo
    // 服务端不兼容 第三方插件 无法mounted后加载
    // import VueAwesomeSwiper from 'vue-awesome-swiper'
    export default {
        name: 'carousel',
        data () {
            return {
                titleWords: [],
                swiperOption: {
                    pagination: '.swiper-pagination',
                    loop: true,
                    paginationClickable: true,
                    spaceBetween: 0,
                    centeredSlides: true,
                    autoplay: 3000,
                    autoplayDisableOnInteraction: false,
                    resistanceRatio: 0,
                    preloadImages: true,
                    lazyLoading: true,
                    lazyLoadingInPrevNext: true,
                    isExternalAccess: null
                }
            };
        },
        props: ['carouselImgData', 'firstTit', 'subtit'],
        mounted: function () {
            this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;
            if (this.isExternalAccess) {
                import('@/util/sys-color-qszq.css').then(module => {
                    console.log('module',module)
                // CSS 已加载
                // 如果使用 CSS Modules，可以通过 module.default 访问
                });
            } else {
                import('@/util/sys-color.css').then(module => {
                // CSS 已加载
                });
            }
        }
    };
</script>

<style lang="less">
    .swiperWrap {
        width: 100%;
        height: 9.3rem;
        position: relative;
        overflow: hidden;
        background: #eff1f4
    }

    .swiper-pagination {
        position: absolute;
        text-align: center;
        transition: .3s;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        z-index: 10;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
        bottom: 10px;
        left: 0;
        width: 100%;
    }

    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
        width: auto !important;
        left: auto !important;
        right: .4rem !important;
        bottom: .4rem !important;
    }

    .swiper-container {
        height: 9.3rem;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        z-index: 1;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 .3rem;
    }

    .swiper-pagination-clickable .swiper-pagination-bullet {
        cursor: pointer;
    }

    .swiper-pagination-bullet {
        width: .3rem;
        height: .3rem;
        display: inline-block;
        border-radius: 100%;
        background: #fff;
        opacity: .2;
    }

    .swiper-pagination-bullet-active {
        width: .3rem;
        height: .3rem;
        background: var(--mainColor) !important;
        opacity: 1;
    }

    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: transform;
        box-sizing: content-box;
    }

    .swiper-slide {
        -webkit-flex-shrink: 0;
        -ms-flex: 0 0 auto;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .swiper-container-android .swiper-slide, .swiper-wrapper {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    .header-mask {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3rem;
        background-image: url(../assets/home/bg-title.png);
        background-repeat: repeat-x;
        background-size: auto 3rem;
    }

    .titleWord {
        width: 100%;
        position: absolute;
        bottom: 1rem;
        color: #fff;
        font-size: 1.1rem;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        z-index: 2;
        box-sizing: border-box;
        padding: 0 .8rem;
    }

    .swiper-container img {
        /*height:100%;*/
    }

    .swiper-lazy {
        // width: 100%;
        display: block;
        min-height: 9.3rem;
    }
</style>



// WEBPACK FOOTER //
// carousel.vue?62a5cf19